import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  TextField,
  Alert,
  Paper,
  List,
  ListItem,
  ListItemText,
  Chip,
  Divider,
} from "@mui/material";
import {
  assignSuperAdminRole,
  checkUserRole,
  listSuperAdmins,
} from "../../DatabaseAPI/AdminUtils";

const AdminUtilsPage = () => {
  const [email, setEmail] = useState("yuvijk5989@gmail.com");
  const [result, setResult] = useState(null);
  const [superAdmins, setSuperAdmins] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSuperAdmins();
  }, []);

  const loadSuperAdmins = async () => {
    const response = await listSuperAdmins();
    if (response.success) {
      setSuperAdmins(response.superAdmins);
    }
  };

  const handleAssignSuperAdmin = async () => {
    if (!email) {
      setResult({ type: "error", message: "Please enter an email address" });
      return;
    }

    setLoading(true);
    const response = await assignSuperAdminRole(email);
    setResult({
      type: response.success ? "success" : "error",
      message: response.message,
    });
    setLoading(false);

    if (response.success) {
      loadSuperAdmins(); // Refresh the list
    }
  };

  const handleCheckRole = async () => {
    if (!email) {
      setResult({ type: "error", message: "Please enter an email address" });
      return;
    }

    setLoading(true);
    const response = await checkUserRole(email);
    setResult({
      type: "info",
      message: response.exists
        ? `User exists with role: ${response.role}`
        : "User does not exist in the system",
    });
    setLoading(false);
  };

  return (
    <Container>
      <Typography variant="h4" sx={{ my: 3 }}>
        Admin Utilities
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Assign SuperAdmin Role
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <TextField
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            variant="outlined"
          />
          <Button
            variant="contained"
            onClick={handleAssignSuperAdmin}
            disabled={loading}
            sx={{ minWidth: 150 }}
          >
            {loading ? "Processing..." : "Assign SuperAdmin"}
          </Button>
          <Button
            variant="outlined"
            onClick={handleCheckRole}
            disabled={loading}
            sx={{ minWidth: 120 }}
          >
            Check Role
          </Button>
        </Box>

        {result && (
          <Alert severity={result.type} sx={{ mt: 2 }}>
            {result.message}
          </Alert>
        )}
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Current SuperAdmins
        </Typography>

        {superAdmins.length > 0 ? (
          <List>
            {superAdmins.map((admin, index) => (
              <React.Fragment key={admin.id}>
                <ListItem>
                  <ListItemText
                    primary={admin.email}
                    secondary={`Created: ${
                      admin.createdAt
                        ? new Date(
                            admin.createdAt.seconds * 1000
                          ).toLocaleDateString()
                        : "Unknown"
                    }`}
                  />
                  <Chip label="SuperAdmin" color="error" size="small" />
                </ListItem>
                {index < superAdmins.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Typography color="text.secondary">No superadmins found</Typography>
        )}
      </Paper>
    </Container>
  );
};

export default AdminUtilsPage;
